import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const IncludedYourPackage = ({ addOns, onAdd, onRemove }) => {
    const { t } = useTranslation();
    const [newAddOn, setNewAddOn] = useState({
        description: '',
    });

    const handleAddNew = () => {
        if (newAddOn.description) {
            onAdd(newAddOn);
            setNewAddOn({ description: '' });
        }
    };

    return (
        <div className="quotation-packages-section">
            <div className="quotation-packages-header">
                <h5 className="quotation-packages-title">{t('included-your-package')}</h5>
              
            </div>

            {/* Add-ons List */}
            <div className="quotation-packages-list">
                <div className="quotation-packages-list-header">
                    <span className="quotation-package-col quotation-package-col-description">{t('description')}</span>
                </div>

     
                {/* Add New Add-on Form */}
                <div className="quotation-package-new-form">
                   
                    <input
                        type="text"
                        className="quotation-package-input quotation-package-col quotation-package-col-description"
                        placeholder={t('upgraded-private-room-with-ensuite-assistant')}
                        value={newAddOn.description}
                        onChange={(e) => setNewAddOn({ ...newAddOn, description: e.target.value })}
                    />
                    <div className="quotation-package-col quotation-package-col-actions">
                        <button 
                            className="quotation-package-add-btn"
                            onClick={handleAddNew}
                            disabled={!newAddOn.description}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            {addOns.length === 0 ? (
                    <div className="quotation-packages-empty">
                        <p>{t('no-packages-added-yet')}</p>
                    </div>
                ) : (
                    addOns.map((packageItem, index) => (
                        <div key={index} className="quotation-package-item">
                           
                            <span className="quotation-package-col quotation-package-col-description">
                                {packageItem.description}
                            </span>
                          
                            <div className="quotation-package-col quotation-package-col-actions">
                                <button 
                                    className="quotation-package-remove-btn"
                                    onClick={() => onRemove(index)}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    ))
                )}

          
        </div>
    );
};

export default IncludedYourPackage;

